import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ShareCardButton({ id }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/admin/listener-stories/${id}/share-card.png`, { responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "umbra-story.png";
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not make the share card.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={download} disabled={busy} data-testid={`admin-story-share-card-${id}`}
      className="mt-3 inline-flex items-center gap-2 min-h-[36px] font-sans text-[0.65rem] uppercase tracking-[0.22em] text-terracotta hover:text-bone-100 transition-colors disabled:opacity-50">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />}
      Download share card · 1080×1350
    </button>
  );
}
